/* eslint-disable camelcase */

import i18n from 'src/i18n.js';

const t = (key) => i18n.t(key);
export const AppConstants = {
    HTTP_Methods: {
        API_GET: 'GET',
        API_POST: 'POST',
        API_DELETE: 'DELETE',
        API_PUT: 'PUT',
    },
    CACHE_MAX_AGE: 1000 * 60 * 480,
    CACHE_CAPACITY: 100,
    POUCH_DB_NF: '404',
    SIGN_IN: 'Sign in to Application',
    DISPLAY_PAGE: 'page',
    LOGOUT_USER_SESSION:
        'Sorry there was an issue fetching your login information. Please click CLOSE to sign back into your account.',
    LOGOUT_API_SESSION:
        'Sorry there was an issue fetching your login information. Please click OK to sign back into your account.',
    SESSION_NOTIFICATION:
        'Your session is about to expire in next 5 mins. Please click OK to extend this session and CANCEL to Logout',
    DATE_PICKER: 'DATE_PICKER',
};

export const CTA_IDS = {
    viewOrder: 'CTA_001',
    delete: 'CTA_002',
    createTemplate: 'CTA_004',
    editOrder: 'CTA_005',
    copyOrder: 'CTA_026',
    noUsageToReport: 'CTA_007',
    requestInvoice: 'CTA_009',
    reportUsage: 'CTA_012',
    reportPayment: 'CTA_013',
    billingSummary: 'CTA_014',
    shippingTracking: 'CTA_015',
    assignCredit: 'CTA_017',
    viewUsageReports: 'CTA_018',
    mazorNavCode: 'CTA_019',
    transfer: 'CTA_020',
    procedureData: 'CTA_022',
    viewAdjustments: 'CTA_011',
    unidPostponed: 'CTA_023',
    caseCancelOrPostpone: 'CTA_024',
    retriggerNotification:'CTA_025',
    addReportUsage: 'CTA_027',
};

export const ORDER_TYPES = {
    surgery: 'ZLC',
    usage: 'ZLB',
};
export const COPY_CTA_IDS = ['CTA_026', 'CTA_003', 'CTA3'];

export const isCopyCtaId = (ctaId) =>
    typeof ctaId === 'string' && COPY_CTA_IDS.includes(ctaId);

export const TRUE_COPY_CTA_IDS = ['CTA_003', 'CTA3'];

export const isTrueCopyCtaId = (ctaId) =>
    typeof ctaId === 'string' && TRUE_COPY_CTA_IDS.includes(ctaId);

export const NON_MATERIAL_CFN_PATTERN = /freight/i;

export const isNonMaterialCfn = (cfn) =>
    typeof cfn === 'string' && NON_MATERIAL_CFN_PATTERN.test(cfn.trim());

// All user roles
export const SR_USER_ROLE = 'MDT Spine Sales Rep';
export const CS_USER_ROLE = 'MDT Spine CS';
export const CC_USER_ROLE = 'MDT Spine CC';
export const ITA_USER_ROLE = 'MDT Spine ITA';
export const FIA_USER_ROLE = 'MDT Spine FIA';
export const FIM_USER_ROLE = 'MDT Spine FIM';
export const CSR_USER_ROLE = 'MDT Spine CSR';
export const DM_USER_ROLE = 'MDT Spine DM';
export const SM_USER_ROLE = 'MDT Spine SM';
export const PL_USER_ROLE = 'MDT Spine 3PL';
export const DCA_USER_ROLE = 'MDT Spine DCA';
export const LATAM_USER_ROLE = 'MDT Spine LATAM Rep';
export const RCM_USER_ROLE = 'MDT Spine RCM';
export const RVP_USER_ROLE = 'MDT Spine RVP';
export const SOC_USER_ROLE = 'MDT Spine SOC';
export const SP_USER_ROLE = 'MDT Spine SP';
export const DS_USER_ROLE = 'MDT Spine DS';

export const MENU = 'MENU';
export const PROXY = 'PROXY';
export const INVENTORY = 'INVENTORY';
export const REPORT_USAGE= 'REPORT_USAGE';
export const SCHEDULE_SURGERY='SCHEDULE_SURGERY';
export const MAST = 'MAST';
export const CONSIGNMENT_BILLING = 'CONSIGNMENT_BILLING';
export const CONSIGNMENT_REPLENISHMENT ='CONSIGNMENT_REPLENISHMENT';
export const REPLENISHMENT ='REPLENISHMENT';
export const EQUITY = 'EQUITY';
export const SETTINGS = 'SETTINGS';
export const ORDERS = 'ORDERS';
export const REPORT_USAGE_SURGERY= 'REPORT_USAGE,SCHEDULE_SURGERY';
export const REPORT_USAGE_MAST= 'REPORT_USAGE,MAST';
export const CONSIGNMENT_RETURN = 'CONSIGNMENT_RETURN';
export const CONSIGNMENT_ADD = 'CONSIGNMENT_ADD';
export const REPORT_PROCEDURE_DATA =  'REPORT_PROCEDURE_DATA';
export const TEMPLATES ='TEMPLATES';
export const NO_USAGE_REPORT = 'NO_USAGE_REPORT';
export const FIELD_INVENTORY_DASHBOARD = 'FIELD_INVENTORY_DASHBOARD';
// All user rules with status
export const ALL_USER_ROLES = [
    { role: SR_USER_ROLE, enabled: true },
    { role: CS_USER_ROLE, enabled: true },
    { role: CC_USER_ROLE, enabled: true },
    { role: FIM_USER_ROLE, enabled: true },
    { role: FIA_USER_ROLE, enabled: true },
    { role: ITA_USER_ROLE, enabled: true },
    { role: CSR_USER_ROLE, enabled: true },
    { role: DM_USER_ROLE, enabled: true },
    { role: SM_USER_ROLE, enabled: true },
    // { role: PL_USER_ROLE, enabled: false },
    { role: DCA_USER_ROLE, enabled: true },
    { role: RCM_USER_ROLE, enabled: true },
    { role: RVP_USER_ROLE, enabled: true },
    { role: SP_USER_ROLE, enabled: true },
    // { role: SOC_USER_ROLE, enabled: false },
    // { role: LATAM_USER_ROLE, enabled: true },
];
export const SURGERY_TEMPLATE_MANDATORY_FIELDS = [
    {
        role: SR_USER_ROLE,
        expirationField: false,
        showFavouriteIcon: true,
    },
    {
        role: CS_USER_ROLE,
        expirationField: false,
        showFavouriteIcon: true,
    },
    {
        role: CC_USER_ROLE,
        expirationField: true,
        showFavouriteIcon: false,
    },
    {
        role: CSR_USER_ROLE,
        expirationField: false,
        showFavouriteIcon: false,
    },
    {
        role: DM_USER_ROLE,
        expirationField: false,
        showFavouriteIcon: true,
    },
    {
        role: SM_USER_ROLE,
        expirationField: false,
        showFavouriteIcon: true,
    },
];
export const SURGERY_REVIEW_MANDATORY_FIELDS = [
    {
        role: SR_USER_ROLE,
        reviewAcknowledgment: true,
        createTemplate: true,
    },
    {
        role: CS_USER_ROLE,
        reviewAcknowledgment: true,
        createTemplate: true,
    },
    {
        role: CC_USER_ROLE,
        reviewAcknowledgment: false,
        createTemplate: true,
    },
    {
        role: CSR_USER_ROLE,
        reviewAcknowledgment: false,
        createTemplate: false,
    },
    {
        role: DM_USER_ROLE,
        reviewAcknowledgment: true,
        createTemplate: true,
    },
    {
        role: SM_USER_ROLE,
        reviewAcknowledgment: true,
        createTemplate: true,
    },
];

export const SURGERY_DETAILS_INFO_MANDATORY_FIELDS = [
    {
        role: SR_USER_ROLE,
        mandatoryFields: ['districtId', 'territoryId', 'accountId'],
        showDetailsTemplate: true,
    },
    {
        role: CS_USER_ROLE,
        mandatoryFields: ['districtId', 'territoryId', 'accountId'],
        showDetailsTemplate: true,
    },
    {
        role: CC_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'patientContactName',
            'patientContactNumber',
        ],
        showDetailsTemplate: false,
    },
    { role: FIA_USER_ROLE, mandatoryFields: [] },
    { role: ITA_USER_ROLE, mandatoryFields: [] },
    {
        role: CSR_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'patientContactName',
            'patientContactNumber',
        ],
        showDetailsTemplate: false,
    },
    {
        role: DM_USER_ROLE,
        mandatoryFields: ['territoryId', 'accountId'],
        showDetailsTemplate: true,
    },
    {
        role: SM_USER_ROLE,
        mandatoryFields: ['accountId'],
        showDetailsTemplate: true,
    },
];

export const EQUITY_USER_MANDATORY_FIELDS = [
    {
        role: SR_USER_ROLE,
        mandatoryFields: ['districtId', 'territoryId', 'accountId'],
    },
    {
        role: CS_USER_ROLE,
        mandatoryFields: ['districtId', 'territoryId', 'accountId'],
    },
    {
        role: CC_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'patientContactName',
            'patientContactNumber',
        ],
    },
    // { role: FIM_USER_ROLE, mandatoryFields: [] },
    { role: FIA_USER_ROLE, mandatoryFields: [] },
    { role: ITA_USER_ROLE, mandatoryFields: [] },
    {
        role: CSR_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'patientContactName',
            'patientContactNumber',
        ],
    },
    { role: DM_USER_ROLE, mandatoryFields: ['accountId'] },
    { role: SM_USER_ROLE, mandatoryFields: ['accountId'] },
];

export const CONSIGNMENT_ADD_MANDATORY_FIELDS = [
    {
        role: SR_USER_ROLE,
        mandatoryFields: ['districtId', 'territoryId', 'accountId'],
    },
    {
        role: CS_USER_ROLE,
        mandatoryFields: ['districtId', 'territoryId', 'accountId'],
    },
    {
        role: CC_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'patientContactName',
            'patientContactNumber',
        ],
    },
    // { role: FIM_USER_ROLE, mandatoryFields: [] },
    { role: FIA_USER_ROLE, mandatoryFields: [] },
    { role: ITA_USER_ROLE, mandatoryFields: [] },
    {
        role: CSR_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'patientContactName',
            'patientContactNumber',
        ],
    },
    { role: DM_USER_ROLE, mandatoryFields: ['accountId'] },
    { role: SM_USER_ROLE, mandatoryFields: ['accountId'] },
];

export const CONSIGNMENT_RETURN_MANDATORY_FIELDS = [
    {
        role: SR_USER_ROLE,
        mandatoryFields: ['districtId', 'territoryId', 'accountId'],
    },
    {
        role: CS_USER_ROLE,
        mandatoryFields: ['districtId', 'territoryId', 'accountId'],
    },
    {
        role: CC_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'patientContactName',
            'patientContactNumber',
        ],
    },
    // { role: FIM_USER_ROLE, mandatoryFields: [] },
    { role: FIA_USER_ROLE, mandatoryFields: [] },
    { role: ITA_USER_ROLE, mandatoryFields: [] },
    {
        role: CSR_USER_ROLE,
        mandatoryFields: [
            'accountId',
        ],
    },
    { role: DM_USER_ROLE, mandatoryFields: ['accountId'] },
    { role: SM_USER_ROLE, mandatoryFields: ['accountId'] },
];

export const CONSIGNMENT_USER_MANDATORY_FIELDS = [
    {
        role: SR_USER_ROLE,
        mandatoryFields: [
            'districtId',
            'territoryId',
            'accountId',
            'hrefId',
            'patientFirstName',
            'patientLastName',
            'implantDate',
            'physicianId',
        ],
    },
    {
        role: CS_USER_ROLE,
        mandatoryFields: [
            'districtId',
            'territoryId',
            'accountId',
            'hrefId',
            'patientFirstName',
            'patientLastName',
            'implantDate',
            'physicianId',
        ],
    },
    {
        role: CC_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'hrefId',
            'patientFirstName',
            'patientLastName',
            'implantDate',
            'physicianId',
        ],
    },
    // { role: FIM_USER_ROLE, mandatoryFields: [] },
    { role: FIA_USER_ROLE, mandatoryFields: [] },
    { role: ITA_USER_ROLE, mandatoryFields: [] },
    {
        role: CSR_USER_ROLE,
        mandatoryFields: [
            'accountId',
        ],
    },
    {
        role: DM_USER_ROLE,
        mandatoryFields: [
            'accountId',
            'hrefId',
            'patientFirstName',
            'patientLastName',
            'implantDate',
            'physicianId',
        ],
    },
    { role: SM_USER_ROLE, mandatoryFields: ['accountId'] },
];

// export const EQUITY_USER_PAGE_VISIBILITY_RULE = [
//     {
//         role: SR_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'RW',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             'scheduleSurgery',
//             'modifySurgery',
//             'transferSurgery',
//             'settings',
//             'announcements',
//             'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             'equity',
//             'modifyEquity',
//             'consignmentBilling',
//             'consignmentReturn',
//             'inventory',
//             'consignmentReturnInventory',
//             // 'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             //'admin',
//             'templates',
//             'receiveSets',
//         ],
//     },
//     {
//         role: CS_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'RW',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             'scheduleSurgery',
//             'modifySurgery',
//             'transferSurgery',
//             'settings',
//             'announcements',
//             'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             'equity',
//             'modifyEquity',
//             'consignmentBilling',
//             'consignmentReturn',
//             'inventory',
//             'consignmentReturnInventory',
//             // 'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             // 'admin',
//             'templates',
//             'receiveSets',
//         ],
//     },
//     {
//         role: CC_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'RW',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             'scheduleSurgery',
//             'modifySurgery',
//             'transferSurgery',
//             // 'settings',
//             'announcements',
//             'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             'equity',
//             'modifyEquity',
//             'consignmentBilling',
//             'consignmentReturn',
//             'inventory',
//             'consignmentReturnInventory',
//             'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             'adminView',
//             'templates',
//             'receiveSets',
//         ],
//     },
//     // {
//     //     role: FIM_USER_ROLE,
//     //     pageRule: {
//     //         name: 'createOrder',
//     //         rule: 'R',
//     //     },
//     // },
//     {
//         role: FIA_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'R',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             // 'scheduleSurgery',
//             // 'modifySurgery',
//             // 'transferSurgery',
//             'settings',
//             'announcements',
//             // 'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             // 'equity',
//             // 'modifyEquity',
//             // 'consignmentBilling',
//             // 'consignmentReturn',
//             // 'inventory',
//             // 'consignmentReturnInventory',
//             // 'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             // 'admin',
//             //'templates',
//             'receiveSets',
//         ],
//     },
//     {
//         role: FIM_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'R',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             // 'scheduleSurgery',
//             // 'modifySurgery',
//             // 'transferSurgery',
//             'settings',
//             'announcements',
//             // 'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             // 'equity',
//             // 'modifyEquity',
//             // 'consignmentBilling',
//             // 'consignmentReturn',
//             // 'inventory',
//             // 'consignmentReturnInventory',
//             // 'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             'adminView',
//             //'templates',
//             'receiveSets',
//         ],
//     },

//     {
//         role: ITA_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'R',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             // 'scheduleSurgery',
//             // 'modifySurgery',
//             // 'transferSurgery',
//             'settings',
//             'announcements',
//             // 'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             // 'equity',
//             // 'modifyEquity',
//             // 'consignmentBilling',
//             // 'consignmentReturn',
//             // 'inventory',
//             // 'consignmentReturnInventory',
//             'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             'adminView',
//             'templates',
//             'receiveSets',
//         ],
//     },
//     {
//         role: CSR_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'RW',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             'scheduleSurgery',
//             'modifySurgery',
//             'transferSurgery',
//             'settings',
//             'announcements',
//             'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             'equity',
//             'modifyEquity',
//             'consignmentBilling',
//             'consignmentReturn',
//             'inventory',
//             'consignmentReturnInventory',
//             // 'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             // 'admin',
//             'templates',
//             'receiveSets',
//         ],
//     },
//     {
//         role: DM_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'RW',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             'scheduleSurgery',
//             'modifySurgery',
//             'transferSurgery',
//             'settings',
//             'announcements',
//             'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             'equity',
//             'modifyEquity',
//             'consignmentBilling',
//             'consignmentReturn',
//             'inventory',
//             'consignmentReturnInventory',
//             // 'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             // 'admin',
//             'templates',
//             'receiveSets',
//         ],
//     },
//     {
//         role: SM_USER_ROLE,
//         pageRule: {
//             name: 'createOrder',
//             rule: 'RW',
//         },
//         urlAccess: [
//             '',
//             'orders',
//             'scheduleSurgery',
//             'modifySurgery',
//             'transferSurgery',
//             'settings',
//             'announcements',
//             'reportUsage',
//             'nutrprocedure',
//             'maintainance',
//             'accounts',
//             'links',
//             'equity',
//             'modifyEquity',
//             'consignmentBilling',
//             'consignmentReturn',
//             'inventory',
//             'consignmentReturnInventory',
//             // 'ImpersonationLanding',
//             'physicians',
//             'proxies',
//             'productGuide',
//             // 'admin',
//             'templates',
//             'receiveSets',
//         ],
//     },
// ];
export const SCROLL_BAR = {
    show: 'block',
    thumb_color: '#00000029',
    width: '10px',
    border_radius: '20px',
};
export const CALENDER_SHARING_TEXTS = () => [
    {
        header: t('settings.SetupCalendarsharing'),
        headerData: [
            {
                text: t('settings.TurnOnCalendarSharing'),
                key: '',
            },
            {
                text: t('settings.CopySharinglink'),
                key: '',
            },
            {
                text: t('settings.PasteCalendar'),
                key: '',
            },
            {
                text: t('settings.newsurgery'),
                textBold: '8 hours',
                textRest: t('settings.toanysharedCalendar'),
                key: '',
            },
        ],
    },
    {
        header: t('settings.CancelCalendars'),
        headerData: [
            {
                text: t('settings.CancelAllCalendars'),
                key: '',
            },
        ],
    },
];
export const IMPERSONATED_URL = '/occ/v2/mdt_b2bsite_us/user';
export const UNAUTHORIZED_STATUS_CODE = 401;
export const UNAUTHORIZED_API_STATUS_CODE = 403;
export const UNAUTHORIZED_TYPE = 'InvalidTokenError';
export const API_CACHE_MAX_AGE = 30 * 60 * 1000; // 30 mins
export const REGEX_WITH_SPECIFIC_CHAR = /^[-_.\w\s]*$/;

//For dynatrace indication
export const pageNames = {
    surgeryCreateTemplate: 'Surgery-CreateTemplate',
    surgeryDetails: 'Surgery-Details',
    surgeryCart: 'Surgery-Cart',
    surgeryShipping: 'Surgery-Shipping',
    surgeryReviewAndSubmit: 'Surgery-ReviewAndSubmit',
    surgerySubmit: 'Surgery-Submit',
    surgeryProductGuide: 'Surgery-ProductGuide',
    surgeryProductSearch: 'Surgery-ProductSearch',
    surgeryQuickOrder: 'Surgery-QuickOrder',
    surgeryProductTemplates: 'Surgery-ProductTemplates',
    mastCreateTemplate: 'MAST-CreateTemplate',
    mastDetails: 'MAST-Details',
    mastCart: 'MAST-Cart',
    mastShipping: 'MAST-Shipping',
    mastReviewAndSubmit: 'MAST-ReviewAndSubmit',
    mastSubmit: 'MAST-Submit',
    mastProductGuide: 'MAST-ProductGuide',
    mastProductSearch: 'MAST-ProductSearch',
    mastQuickOrder: 'MAST-QuickOrder',
    mastProductTemplates: 'MAST-ProductTemplates',
    ordersUsageReport: 'Orders-UsageReport',
    ordersViewReport: 'Orders-ViewReport',
    orders: 'Orders',
    ordersSummary: 'Orders-Summary',
    reportUsageSurgeryOrReport: 'ReportUsage-SurgeryOrReport',
    reportUsageUnidSurgeryInfo: 'ReportUsage-UnidSurgeryInfo',
    reportUsageProcedure: 'ReportUsage-Procedure',
    reportUsagePriceOverRide: 'ReportUsage-PriceOverRide',
    reportUsageReportPayment: 'ReportUsage-ReportPayment',
    reportUsageRecord: 'ReportUsage-Record',
    reportUsageReplen: 'ReportUsage-Replen',
    reportUsageReviewAndSubmit: 'ReportUsage-ReviewAndSubmit',
    equityCreateTemplate: 'Equity-CreateTemplate',
    equityAccount: 'Equity-Account',
    equityCart: 'Equity-Cart',
    equityShipping: 'Equity-Shipping',
    equityReviewAndSubmit: 'Equity-ReviewAndSubmit',
    equitySubmit: 'Equity-Submit',
    equityProductGuide: 'Equity-ProductGuide',
    equityProductSearch: 'Equity-ProductSearch',
    equityQuickOrder: 'Equity-QuickOrder',
    equityProductTemplates: 'Equity-ProductTemplates',
    equityPriceOverride: 'Equity-PriceOverride',
    consignmentAddCreateTemplate: 'ConsignmentAdd-CreateTemplate',
    consignmentAddAccount: 'ConsignmentAdd-Account',
    consignmentAddCart: 'ConsignmentAdd-Cart',
    consignmentAddShipping: 'ConsignmentAdd-Shipping',
    consignmentAddReviewAndSubmit: 'ConsignmentAdd-ReviewAndSubmit',
    consignmentAddProductGuide: 'ConsignmentAdd-ProductGuide',
    consignmentAddProductSearch: 'ConsignmentAdd-ProductSearch',
    consignmentAddQuickOrder: 'ConsignmentAdd-QuickOrder',
    consignmentAddProductTemplates: 'ConsignmentAdd-ProductTemplates',
    consignmentAddSubmit: 'ConsignmentAdd-Submit',
    consigmentReturnAccount: 'ConsignmentReturn-Account',
    consigmentReturnInventory: 'ConsignmentReturn-Inventory',
    consigmentReturnProducts: 'ConsignmentReturn-Products',
    consigmentReturnReviewAndSubmit: 'ConsignmentReturn-ReviewAndSubmit',
    consignmentReturnSubmit: 'ConsignmentReturn-Submit',
    admin: 'Admin',
    moreAccounts: 'More-Accounts',
    moreAnnouncements: 'More-Announcements',
    moreLinks: 'More-Links',
    morePhysicians: 'More-Physicians',
    moreProductGuide: 'More-ProductGuide',
    moreProxy: 'More-Proxy',
    moreTemplate: 'More-Templates',
    moreEquityTemplate: 'More-Templates-Equity',
    moreSurgeryTemplate: 'More-Templates-Surgery',
    moreEquityTemplateProductGuide: 'More-Templates-Equity-ProductGuide',
    moreEquityTemplateProductSearch: 'More-Templates-Equity-ProductSearch',
    moreEquityTemplateQuickOrder: 'More-Templates-Equity-QuickOrder',
    moreEquityTemplateProductTemplates:
        'More-Templates-Equity-ProductTemplates',
    moreSurgeryTemplateProductGuide: 'More-Templates-Surgery-ProductGuide',
    moreSurgeryTemplateProductSearch: 'More-Templates-Surgery-ProductSearch',
    moreSurgeryTemplateQuickOrder: 'More-Templates-Surgery-QuickOrder',
    moreSurgeryTemplateProductTemplates:
        'More-Templates-Surgery-ProductTemplates',
    consignmentBillingAccount: 'ConsignmentBilling-Account',
    consignmentBilling: 'ConsignmentBilling-Billing',
    consignmentBillingInventory: 'ConsignmentBilling-Inventory',
    consignmentBillingReplen: 'ConsignmentBilling-Replen',
    consignmentBillingPayment: 'ConsignmentBilling-Payment',
    consignmentBillingReview: 'ConsignmentBilling-ReviewAndSubmit',
    consignmentBillingSubmit: 'ConsignmentBilling-Submit',
    calendar:'Calendar',
    inventory:'Inventory-ReceiveSets',
    fieldInventoryDashboard: 'More-FieldInventoryDashboard',
};

export const PAGE_VISIBILITY_RULE = {
    name: 'createOrder',
    rule: 'RW',
};

//For OrderStatus
export const OrderStatuses = () => ({
    paymentInformationNeeded: t('calendar.actionPanel.awaitingPO'),
    billingIssues: t('orders.orderStatuses.billingIssues'),
});

export const ALLDISTRICTS = 'ALL_Districts';
export const ALLTERRITORIES = 'All_Territories';
export const ERRORDETAILS = () => [
    {
        title: t('errorDetails.pageNotFound.title'),
        content: t('errorDetails.pageNotFound.content'),
        helpLineText: t('errorDetails.pageNotFound.helpLinetext'),
    },
    {
        title: t('errorDetails.forbidden.title'),
        content: t('errorDetails.forbidden.content'),
        helpLineText: t('errorDetails.forbidden.helpLineText'),
    },
];

export const ADMINFILTERPARAMETERS = [
    { salesOrgView: '', districts: '', territory: '', role: '' },
    {
        salesOrgView: 'SALESORGVIEW',
        districts: 'DISTRICTS',
        territory: 'TERRITORY',
        role: 'ROLE',
    },
    {
        salesOrgView: 'ADMIN_FILTER_SALESORGVIEW_SUCCESS',
        districts: 'ADMIN_FILTER_DISTRICTS_SUCCESS',
        territory: 'ADMIN_FILTER_TERRITORY_SUCCESS',
        role: 'ADMIN_FILTER_ROLE_SUCCESS',
    },
    {
        salesOrgView: '',
        districtView: 'districts',
        territoryView: 'territory',
        roleView: 'role',
    },
    {
        salesOrgView: 'salesOrgs',
        districtView: 'districtCode',
        territoryView: 'territoryCode',
        roleView: 'userRole',
    },
    {
        salesOrgView: 'salesOrgs',
        districts: 'aardt/admin/districts',
        territory: 'aardt/admin/territory',
        role: 'users/roles',
    },
    {
        salesOrgView: 'SALESORGVIEW',
        districts: 'DISTRICTS',
        territory: 'TERRITORY',
        role: 'ROLE',
    },
    {
        salesOrgView: 'salesOrgView',
        districts: 'districts',
        territory: 'territories',
        role: 'userRoles',
    },
    {
        salesOrgView: 'salesOrgView',
        districts: { id: 'districtCode', name: 'districtName' },
        territory: { id: 'terrirotryCode', name: 'terrirotryName' },
        role: { id: 'userRolesCode', name: 'userRolesName' },
    },
    {
        salesOrgView: 'salesOrgView',
        districts: { id: 'All District', name: 'All' },
        territory: { id: 'All Territory', name: 'All' },
        role: { id: 'All', name: 'All' },
    },
    // {
    //     salesOrgView: { default: ['salesOrgs'] },
    //     districtView: {
    //         default: ['territoryView', 'roleView'],
    //         notselected: [],
    //         params: ['territoryView', 'roleView'],
    //     },
    //     territoryView: {
    //         default: ['roleView'],
    //         notSelected: ['districtView'],
    //         params: ['districtView', 'roleView'],
    //     },
    //     roleView: {
    //         default: [],
    //         notSelected: ['districtView', 'territoryView'],
    //         params: ['districtView', 'territoryView'],
    //     },
    // },
    {
        salesOrg: {
            default: ['districts', 'territory', 'role'],
            notselected: [],
            params: [],
            paramsNotNeeded: [],
        },
        districtView: {
            default: ['territory', 'role'],
            notselected: [],
            params: ['salesOrgView'],
            paramsNotNeeded: ['districtCode', 'territoryCode', 'userRole'],
        },
        territoryView: {
            default: ['role'],
            notSelected: ['districtView'],
            params: ['salesOrgView', 'districtView'],
            paramsNotNeeded: ['userRole'],
        },
        roleView: {
            default: [],
            notSelected: ['districtView', 'territoryView'],
            params: ['salesOrgView', 'districtView', 'territoryView'],
            paramsNotNeeded: ['userRole'],
        },
    },
    {
        districts: {
            params: ['salesOrgs'],
        },
        territory: {
            params: ['salesOrgs', 'districtCode'],
        },
        role: {
            params: ['salesOrgs', 'districtCode', 'territoryCode'],
        },
    },
];

export const ADMINFILTER = 'ADMIN_FILTER';
export const SALESORGVIEW = 'salesOrgView';
export const ENVIRONMENTVARIABLE = 'env(safe-area-inset-bottom)';
export const ENABLED = 'ENABLED';
export const VISIBLE = 'VISIBLE';
export const DISABLED = 'DISABLED';
export const MANDATORY = 'YES';
export const NOT_MANDATORY = 'NO';
export const NOT_VISIBLE = 'NOT_VISIBLE';
export const OTHER_PHYSICIAN = 'Other Physician';

export let EQUITY_USER_PAGE_VISIBILITY_RULE;

export const setPageVisibilityRule = (pageRuleList) => {
    EQUITY_USER_PAGE_VISIBILITY_RULE = pageRuleList;
};

export const BASESITEID = 'mdt_b2bsite_us';
export const US_CURRENCY_CODE = 'USD';
export const US_COUNTRY_CODE = 'US';
export const US_LANGUAGE_CODE = 'en-US';
export const JAPAN_SALESORG = 'S024';
export const AU_COUNTRY_CODE = 'AU';


export const routeVisibilityMap = {
    '/': 'calendar',
    '/orders': 'orders',
    '/home': 'calendar',
    '/scheduleSurgery': 'calendar',
    '/modifySurgery/:myCaseRef': 'calendar',
    '/transferSurgery/:myCaseRef': 'calendar',
    '/settings': 'more',
    '/announcements': 'alerts',
    '/reportUsage': 'more',
    '/maintainance': 'admin',
    '/accounts': 'admin',
    '/links': 'more',
    '/equity': 'orders',
    '/modifyEquity/:myCaseRef': 'orders',
    '/consignmentBilling': 'inventory',
    '/consignmentReturn': 'inventory',
    '/inventory': 'inventory',
    '/consignmentReturnInventory': 'inventory',
    '/ImpersonationLanding': 'admin',
    '/physicians': 'admin',
    '/proxies': 'admin',
    '/productGuide': 'productGuide',
    '/adminView': 'admin',
    '/templates': 'admin',
    '/orderHistory': 'more',
    '/backOrders': 'orders',
    '/receiveSets': 'inventory',
    '/consignmentAdd': 'inventory',
    '/fieldInventoryDashboard': 'fieldInventoryDashboard'
    // '/error' - not included, always visible
};


//DatePicker Constants

export const DEFAULT_YEAR_RANGE='2010:2400';
export const DATE_SELECT='#202124';
export const DATE_UNSELECT='#202124';
export const OPACITY_DULL= '0.5';
export const OPACITY= '1';
export const WIDTH='10px !important';

export const ERROR_BOUNDARY_STATUS = true;

export const DATE_FORMAT = {
	DAY: '2-digit',
	MONTH: 'short',
	YEAR: 'numeric',
};

export const LOCALE = 'en';

export const CALENDAR_VIEW = {
	WEEK: 'Week',
	MONTH: 'Month',
};

export const OVERRIDE_ACTIONS = {
	APPROVE: 'APPROVE',
	DENY: 'DENY',
	REASSIGN: 'REASSIGN',
	EDIT: 'EDIT_PRICE_OVERRIDE',
    CANCEL: 'CANCEL_OVERRIDE',
};

// Raw backend uom code for packaging items - displayed as 'PK' (see
// PriceOverrideDataTable.jsx for the existing pattern this reuses).
export const PACKAGING_UOM_CODE = 'packaging-PK';
export const PACKAGING_UOM_DISPLAY = 'PK';



